import React from "react"
import { toMoney } from "../../utils/string_utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "../shared/button/text-button"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import "./entertainment.scss"
library.add(faCheck)

const Entertainment = ({
  text,
  images,
  cost,
  excludeVAT,
  onAddEntertainment,
  selectedEntertainment,
  planID,
  buttonText
}) => (
  <div className="entertainment-page">
    <div className="description">
      <div className="short-text">Entertainment</div>
      {text ? <div className="text">{text}</div> : ""}
      <div className="providerList">
        {images.map((imageData, index) => {
          return (
            <span key={imageData.img}>
              <img src={imageData.img} alt={""} width="45px" />
              {index !== images.length - 1 && (
                <span className="textAfterImage">or</span>
              )}
            </span>
          )
        })}
      </div>
    </div>
    <div className="cost">
      <div className="value">{toMoney(cost)}</div>
      <div className="label">per month</div>
      {excludeVAT ? <div className="vatDescription">(exc. VAT)</div> : ""}
    </div>
    {!selectedEntertainment[planID] ? (
      <div className="add-entertainment-button">
        <Button
          text={buttonText}
          onClick={() => {
            onAddEntertainment(
              selectedEntertainment[planID] === cost ? 0 : cost
            )
          }}
        />
      </div>
    ) : (
      <div className="remove-entertainment-button">
        <div className="added-message">
          <FontAwesomeIcon icon="check" /> Added
        </div>
        <div className="remove-link">
          <div
            onClick={() =>
              onAddEntertainment(
                selectedEntertainment[planID] === cost ? 0 : cost
              )
            }
          >
            Remove this extra
          </div>
        </div>
      </div>
    )}
  </div>
)

export default Entertainment
